import React from 'react';
import Announcements from '../../components/Admin/Announcements/Announcements';
import PageWrapper from '../../components/UI/PageWrapper';

const AnnouncementsPage: React.FC = () => (
  <PageWrapper>
    <Announcements />
  </PageWrapper>
);

export default AnnouncementsPage;
